import API from './Axios.utils';

export const searchCandidates = ({ query, top_k = 10, page = 1, pageSize = 10 }) =>
  API.post('/api/candidates/search', { query, top_k, page, pageSize }).then(res => res.data);

export const fetchIndexStats  = ()                => API.get('/api/candidates/admin/stats').then(res => res.data);
export const fetchIndexStatus = ()                => API.get('/api/candidates/admin/status').then(res => res.data);
export const triggerSeed      = ()                => API.post('/api/candidates/admin/seed').then(res => res.data);
export const resetFailed      = (profileIds = []) =>
  API.post('/api/candidates/admin/reset-failed', { profile_ids: profileIds }).then(res => res.data);
export const pollIndex        = ()                => API.post('/api/candidates/admin/poll').then(res => res.data);
